import store from './store/index'
import { IStore } from './core/interface/IStore'
import { ISysLockScreenModule } from '@/contracts/system-modules/lock-screen/ISysLockScreenModule'
import { IEventBus } from '@/contracts/core/event/interface/IEventBus'
import { EnumSystemEvent } from '@/contracts/core/event/enum/EnumSystemEvent'
import { EventProviderModule } from '@/core/event/EventProvider'

export class LockScreenV1 implements ISysLockScreenModule {
  private static instance: ISysLockScreenModule
  private store: IStore = store()
  private events: IEventBus

  constructor(events: IEventBus = EventProviderModule()) {
    this.events = events
  }

  init(): boolean {
    return true
  }

  lock(): void {
    if (this.store.locked) {
      return
    }
    this.store.locked = true
    this.events.emit(EnumSystemEvent.LOCKED)
  }

  unlock(): void {
    if (!this.store.locked) {
      return
    }
    this.store.locked = false
    this.events.emit(EnumSystemEvent.UNLOCKED)
  }

  hide(): void {
    this.store.locked = false
  }

  isLocked(): boolean {
    return this.store.locked
  }

  static getInstance(): ISysLockScreenModule {
    if (!LockScreenV1.instance) {
      LockScreenV1.instance = new LockScreenV1()
    }
    return LockScreenV1.instance
  }

  getViewPath(): string {
    return '/lock-screen/v1/view/index.vue'
  }
}

export default function(): ISysLockScreenModule {
  return LockScreenV1.getInstance()
}
